__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@mfe/core";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@hookform/resolvers", "3.10.0", () => (() => (__webpack_require__(6912))), 1);
			register("@reduxjs/toolkit", "1.9.7", () => (() => (__webpack_require__(5679))), 1);
			register("axios", "1.13.2", () => (() => (__webpack_require__(4447))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(961))), 1);
			register("react-hook-form", "7.68.0", () => (() => (__webpack_require__(9785))), 1);
			register("react-redux", "8.1.3", () => (() => (__webpack_require__(3103))), 1);
			register("react-router-dom", "6.30.2", () => (() => (__webpack_require__(2648))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(6540))), 1);
			register("zod", "3.25.76", () => (() => (__webpack_require__(7354))), 1);
			initExternal(4802);
			initExternal(2977);
			initExternal(1031);
			initExternal(1036);
			initExternal(4251);
			initExternal(9146);
			initExternal(7383);
			initExternal(8139);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};